"use strict";
/*
 *  Copyright (C) 2020  Attila Aldemir <a_aldemir@hotmail.de>
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU Affero General Public License as published
 *  by the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU Affero General Public License for more details.
 *
 *  You should have received a copy of the GNU Affero General Public License
 *  along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_sha256_1 = require("js-sha256");
var utf8_1 = __importDefault(require("utf8"));
var Helper_1 = __importDefault(require("./utils/Helper"));
var Nonce_1 = __importDefault(require("./utils/Nonce"));
var ClaimService = /** @class */ (function () {
    function ClaimService() {
        this.userData = [];
    }
    ClaimService.prototype.prepareUserData = function (params) {
        var userDataWithNonce = [];
        params.unpreparedUserData.forEach(function (userDataObject) {
            userDataWithNonce.push({
                name: userDataObject.name,
                value: userDataObject.value, nonce: Nonce_1.default.generate()
            });
        });
        return userDataWithNonce;
    };
    ClaimService.prototype.setUserData = function (params) {
        this.userData = params.userData;
    };
    ClaimService.prototype.createHashes = function () {
        var leafHashes = this.createLeafHashes(this.userData);
        var rootHash = this.createRootHash(leafHashes);
        return { rootHash: rootHash, leafHashes: leafHashes };
    };
    ClaimService.prototype.createLeafHashes = function (data) {
        var _this = this;
        var leafHashes = [];
        data.forEach(function (dataObject) {
            var concatData = Helper_1.default.concatObjectValues({
                name: dataObject.name,
                value: dataObject.value,
                nonce: dataObject.nonce
            });
            leafHashes.push(_this.createHash(concatData));
        });
        return leafHashes;
    };
    ClaimService.prototype.createHash = function (data) {
        return js_sha256_1.sha256(utf8_1.default.encode(data));
    };
    ClaimService.prototype.createRootHash = function (leafHashes) {
        var concatLeafHashes = Helper_1.default.concatArrayElements(__spreadArrays(leafHashes));
        return this.createHash(concatLeafHashes);
    };
    ClaimService.prototype.createClaim = function (params) {
        var claimData = this.getClaimData(params.userDataNames);
        var claimDataLeafHashes = this.createLeafHashes(claimData);
        var userDataHashes = this.createHashes();
        var claimLeafHashes = this.getClaimLeafHashes(userDataHashes.leafHashes, claimDataLeafHashes);
        var claimObject = {
            userData: claimData,
            hashes: {
                leafHashes: claimLeafHashes,
                rootHash: userDataHashes.rootHash
            }
        };
        return claimObject;
    };
    ClaimService.prototype.getClaimData = function (userDataNames) {
        var _this = this;
        var claimData = [];
        userDataNames.forEach(function (name) {
            _this.userData.forEach(function (userDataObject) {
                if (name === userDataObject.name) {
                    claimData.push(userDataObject);
                }
            });
        });
        return claimData;
    };
    ClaimService.prototype.getClaimLeafHashes = function (userDataLeafHashes, claimDataLeafHashes) {
        return userDataLeafHashes.filter(function (userDataLeafHash) {
            var addToClaim = true;
            claimDataLeafHashes.forEach(function (claimDataLeafHash) {
                if (userDataLeafHash === claimDataLeafHash) {
                    addToClaim = false;
                }
            });
            return addToClaim;
        });
    };
    ClaimService.prototype.verifyClaim = function (params) {
        var claimDataLeafHashes = this.createLeafHashes(params.claimObject.userData);
        var leafHashes = claimDataLeafHashes.concat(params.claimObject.hashes.leafHashes);
        var rootHash = this.createRootHash(leafHashes);
        return rootHash === params.claimObject.hashes.rootHash;
    };
    return ClaimService;
}());
exports.default = ClaimService;
